import { render, staticRenderFns } from "./UcProductInvoiceGroupLabel.yaml?vue&type=template&id=0f901aa8&component"
import script from "./UcProductInvoiceGroupLabel.yaml?vue&type=script&lang=ts&component"
export * from "./UcProductInvoiceGroupLabel.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports